import { render, staticRenderFns } from "./RecordingPage.vue?vue&type=template&id=784ae78c&scoped=true"
import script from "./RecordingPage.vue?vue&type=script&lang=js"
export * from "./RecordingPage.vue?vue&type=script&lang=js"
import style0 from "./RecordingPage.vue?vue&type=style&index=0&id=784ae78c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784ae78c",
  null
  
)

export default component.exports